import {useCallback, useContext} from "react"
import {ActionContext} from "../../../src/context/ActionContextProvider"
import {Grid, Stack, styled, Typography} from "@mui/material"
import ButtonTemplate from "../widgets/buttons/ButtonTemplate"
import React from "react"

export const cardContainerPrototype = [
    {
        key: "action",
        type: "STRING",
        label: "Action",
        size: 6,
    },
    {
        key: "buttonText",
        type: "STRING",
        label: "Button Text",
        size: 6,
    },
    {
        key: "title",
        type: "STRING",
        label: "Titel",
        size: 6,
    },
    {
        key: "subtitle",
        type: "STRING",
        label: "Subtitle",
        size: 6,
    },
    {
        key: "text",
        type: "STRING",
        label: "Text",
        size: 6,
    },
    {
        key: "size",
        type: "SELECT",
        label: "Größe",
        size: 6,
        options: [
            {
                value: "L",
                label: "Large",
            },
            {
                value: "S",
                label: "Small",
            },
        ]
    },
]

const sizeMap = {
    S: "297px",
    L: "468px",
}

const SubTitle = styled(Typography)(({theme}) => (
    theme.CARD.subtitle
))

const Title = styled(Typography)(({theme}) => (
    theme.CARD.title
))

const CardContainer = ({container}) => {
    const {triggerAction} = useContext(ActionContext)
    const onClick = useCallback(() => {
        triggerAction(container?.action)
    }, [triggerAction, container?.action])

    return (
        <Grid padding="24px" container border="1px solid #CDD5F4"  flexDirection="column" borderRadius="8px" width={sizeMap[container?.size ?? "S"]}>
            {container?.image && <img src={container?.image} alt={container?.title} />}
            <Grid container flexDirection="column" spacing={2}>
                <Grid container spacing={1}>
                    <Grid direction="column">
                        <SubTitle>{container?.subtitle}</SubTitle>
                        <Title>{container?.title}</Title>
                    </Grid>
                    {container?.text && <Grid>
                        <Typography color="#3C5065" fontWeight={500} lineHeight="16px"
                                    fontSize="14px">{container?.text}</Typography>
                    </Grid>}
                </Grid>
                {container?.children && <Stack>
                    {container?.children.map(() => true)}
                </Stack>}
                {container.size === "S" && <Grid container>
                    <ButtonTemplate variant="primary" onClick={onClick}
                                    buttonText={container?.buttonText} />
                </Grid>}
                {container.size === "L" && <Grid container display="flex">
                    <Grid>
                        <ButtonTemplate size="small" variant="primary" onClick={onClick}
                                        buttonText={container?.buttonText} />
                    </Grid>
                </Grid>}
            </Grid>
        </Grid>
    )
}

export default CardContainer
